export function IsNullOrUndefined(value: unknown): value is undefined {
  return (value === null || value === undefined);
}

export function IsNullOrUndefinedOrNaN(value: unknown): value is undefined {
  return IsNullOrUndefined(value) || isNaN(value as number);
}

export function Truncate(input: string, max: number): string {
  return input.length > max ? `${input.substring(0, max).trim()}...` : input;
}
